import { render, staticRenderFns } from "./ListRolePage.vue?vue&type=template&id=5e484cda&"
import script from "./ListRolePage.vue?vue&type=script&lang=js&"
export * from "./ListRolePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports